<template>
  <div class="checkbox" @click="handleClick">
    <v-checkbox
      class="mt-0 pt-0"
      hide-details
      :input-value="inputValue"
    ></v-checkbox>
    <p class="mb-0">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: "ReviewsCheckbox",
  props: {
    inputValue: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: $spacing * 2;
  margin: 0 $spacing * -2;
  color: $text;
  transition: 0.1s ease background;

  &:hover {
    background-color: rgba($text, 0.04);
  }
}
</style>
